module.exports = __webpack_public_path__ + "img/Header_Desktop_Logo.f2fe8369.png";